/*@ngInject*/
const ActionButtonsBarController = function ($rootScope, $scope, $element, $timeout, localization, actionHandler, coreConstant) {

    let contextOrder = {},
        contextActionsArray = [],
        actionReloadTimeout,
        translations;

    this.$onInit = function () {
        $element.addClass('actionButtonsBar');
        $element.addClass(this.context.identifier + 'ActionButtonsBar');

        localization.getTranslations().then((translationsResult) => {
            this.buttonBarActions = [];
            this.groupedIWantToActionsKeys = [];
            this.groupedIWantToActionsMap = {};
            translations = translationsResult;
            this.processActions();
        });

        $scope.$on(coreConstant.event.ACTION_STARTED, (event, promise) => {
            _.each(this.actions, function (contextAction) {
                _.each(contextAction.actions, function (action) {
                    action.temporarilyDisabled = true;
                });
            });
            this.processActions();
            if (!_.isNil(promise)) {
                promise.finally(function () {
                    if (!_.isNil(actionReloadTimeout)) {
                        $timeout.cancel(actionReloadTimeout);
                    }
                    actionReloadTimeout = $timeout(function () {
                        $rootScope.$broadcast(coreConstant.event.RELOAD_ACTIONS);
                    }, 1000);
                });
            }
        });

        $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, () => {
            this.resetTemporarilyDisabledActions();
        });

        $scope.$on('$destroy', function () {
            if (!_.isNil(actionReloadTimeout)) {
                $timeout.cancel(actionReloadTimeout);
            }
        });

    };

    this.resetTemporarilyDisabledActions = function () {
        if (!_.isNil(actionReloadTimeout)) {
            $timeout.cancel(actionReloadTimeout);
        }

        _.each(this.actions, function (contextAction) {
            _.each(contextAction.actions, function (action) {
                action.temporarilyDisabled = false;
            });
        });
    };

    this.getButtonLabel = function (action) {
        let label;
        if (action.labelKey) {
            label = _.get(translations, action.labelKey);
            if (_.isNil(label)) {
                label = action.labelKey;
            }
        }
        else {
            label = _.get(translations, this.context.identifier + '.actions.' + action.name);
            if (!label) {
                label = action.label || action.name;
            }
        }
        return label;
    };

    this.getContextLabel = function (context) {
        let splitContext = _.split(context, '.');
        return _.get(translations, this.context.identifier + '.actions.context.' + splitContext[1]) ? _.get(translations, this.context.identifier + '.actions.context.' + splitContext[1]) : context;
    };

    this.processActions = function () {
        let iWantToActionsMap,
            combinedActions,
            tempGroupedIWantToActionsKeys;

        _.each(this.actions, (contextAction) => {
            _.each(contextAction.actions, (action) => {
                let hiddenInputAction,
                    subText;

                if (!_.isNil(this.hiddenInputActions)) {
                    hiddenInputAction = this.hiddenInputActions[action.name];
                    if (!_.isNil(hiddenInputAction)) {
                        action.isHiddenInputAction = true;
                        action.accept = hiddenInputAction;
                    }
                    else {
                        action.isHiddenInputAction = false;
                    }
                }
                else {
                    action.isHiddenInputAction = false;
                }

                if (!_.isNil(this.actionSubTexts)) {
                    subText = this.actionSubTexts[action.name];
                    if (!_.isNil(subText)) {
                        action.hasSubText = true;
                        action.subTextClass = subText.class;
                        action.subText = subText.text;
                    }
                    else {
                        action.hasSubText = false;
                    }
                }
                else {
                    action.hasSubText = false;
                }

                action.identifier = _.camelCase(action.name);
                action.buttonLabel = this.getButtonLabel(action);
            });
        });

        contextActionsArray = actionHandler.processContextActions(this.actions, this.context.model.hierarchicalContextList);
        combinedActions = this.createAllActionsArray(this.actions);

        this.buttonBarActions = actionHandler.getButtonBarActions(combinedActions);

        this.groupedIWantToActionsKeys = null;
        if (!this.hideDropdown) {
            iWantToActionsMap = actionHandler.getIWantToActions(combinedActions, this.context.actions, this.context.fallthrough);

            this.groupedIWantToActionsMap = {};
            _.forOwn(iWantToActionsMap, (actions, context) => {
                this.groupedIWantToActionsMap[context] = _.orderBy(_.groupBy(actions, 'groupName'), [function (group) {
                    return group[0].groupOrdering;
                }]);

                this.groupedIWantToActionsMap[context].hideGroupHeader = context === coreConstant.CONTEXT_NONE;
            });

            tempGroupedIWantToActionsKeys = _.orderBy(_.keys(this.groupedIWantToActionsMap), [function (context) {
                return contextOrder[context];
            }], ['desc']);

            this.groupedIWantToActionsKeys = [];
            _.each(tempGroupedIWantToActionsKeys, (key) => {
                this.groupedIWantToActionsKeys.push({
                    key: key,
                    contextLabel: this.getContextLabel(key)
                });
            });
        }

        $rootScope.$broadcast(coreConstant.event.ACTION_BUTTONS_PROCESSING_COMPLETED);
    };

    this.createAllActionsArray = function (contextActionsArray) {
        let allActions = [];

        if (contextActionsArray) {
            _.each(contextActionsArray, function (contextActions) {
                if (!_.isNil(contextActions) && !_.isEmpty(contextActions.actions)) {
                    allActions.push(_.filter(_.cloneDeep(contextActions.actions), function (a) {
                        return a.valid;
                    }));
                    contextOrder[contextActions.contextType] = _.get(contextActions.actions, _.keys(contextActions.actions)[0]).contextOrdering;
                }
            });
        }

        return allActions;
    };

    this.handleButtonClick = function (action, event) {
        if (action.valid && !action.enabled && action.notes) {
            event.stopPropagation();
        }
        else {
            this.notifyActionClicked({action: action});
        }
    };

    this.handleHiddenInputAction = function (action, file) {
        this.notifyActionClicked({action: action, file: file});
    };

    this.$onChanges = function () {
        this.processActions();
        this.resetTemporarilyDisabledActions();
    };

    this.getActionClass = function (action) {
        if (action.nextAction && !(action.valid && !action.enabled && action.notes)) {
            return 'btn-success';
        }
        else if (action.previousAction && !(action.valid && !action.enabled && action.notes)) {
            return 'btn-default';
        }
        else if (action.valid && !action.enabled && action.notes) {
            return 'disabled';
        }
    };
};

angular.module('umCore')
    .controller('actionButtonsBarController', ActionButtonsBarController);
